import { Routes, Route } from "react-router-dom";
import TranscriptDetail from "./TranscriptDetail";

export default function TranscriptsRoutes() {
  return (
    <Routes>
      <Route path=":id" element={<TranscriptDetail />} />
    </Routes>
  );
}
